module.exports = __webpack_public_path__ + "img/rmt-4390-front.f4dd4d84.png";